/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./search-input.vue?vue&type=template&id=06e0dc5c&scoped=true&"
import script from "./search-input.vue?vue&type=script&lang=ts&"
export * from "./search-input.vue?vue&type=script&lang=ts&"
import style0 from "./search-input.vue?vue&type=style&index=0&id=06e0dc5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e0dc5c",
  null
  
)

export default component.exports